import type { CSSProperties } from "react";
import { site } from "../../siteConfig";

/**
 * Botón flotante de WhatsApp. Usa el teléfono de siteConfig.ts (con lada de país, por ejemplo +52 477 000 0000) y abre
 * el chat con un mensaje prellenado. Si el teléfono está vacío o es el de ejemplo, no se muestra.
 * Para quitarlo, borra <WhatsAppButton /> de donde se usa; para cambiar el texto, pasa la propiedad «message».
 */
export function WhatsAppButton({ message, label = "Escríbenos por WhatsApp" }: { message?: string; label?: string }) {
  const number = site.phone.replace(/\D/g, "");
  if (number.length < 10 || /^0+$/.test(number)) return null;
  const text = message ?? `Hola, vi su sitio web de ${site.name} y me gustaría recibir más información.`;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={`${label} (abre WhatsApp)`} title={label} style={button}>
      <svg viewBox="0 0 32 32" width="30" height="30" aria-hidden="true" focusable="false">
        <path fill="#fff" d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3Zm0 23.4c-2.1 0-4.1-.6-5.9-1.7l-.4-.2-3.8 1.2 1.2-3.7-.3-.4a10.4 10.4 0 0 1-1.7-5.8C5.1 10 10 5.3 16 5.3S26.9 10 26.9 15.8 22 26.4 16 26.4Zm6-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2l-1 1.2c-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6.3-.5c.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.2 1.4 3.4c.2.2 2.4 3.6 5.7 5 .8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4Z" />
      </svg>
    </a>
  );
}

const button: CSSProperties = {
  position: "fixed", right: "1.25rem", bottom: "1.25rem", zIndex: 60,
  display: "grid", placeItems: "center", width: "3.5rem", height: "3.5rem", borderRadius: "50%",
  background: "#25D366", boxShadow: "0 12px 28px -8px rgb(0 0 0 / .45)",
};
